var _path, _g, _g2, _path2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 260,
    viewBox: "0 0 380 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_61)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_61",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 60,
    width: 320,
    height: 140
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8_61",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -20,
    y: -70,
    width: 400,
    height: 400
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380 -70H-20V330H380V-70ZM111.745 -28.3241L94.4214 -45.6482L59.7731 -11L77.0972 6.32415L201.194 130.421L77.0972 254.519L59.7731 271.843L94.4214 306.491L111.745 289.167L253.167 147.745C262.735 138.178 262.735 122.665 253.167 113.097L111.745 -28.3241Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8_61)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 110,
    width: 320,
    height: 40,
    rx: 20,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 60,
    width: 320,
    height: 40,
    rx: 20,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 160,
    width: 320,
    height: 40,
    rx: 20,
    fill: "#D9D9D9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_61)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -302,
    y: -476,
    width: 1236,
    height: 1202,
    fill: "#47DEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8_61",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 25,
    width: 126,
    height: 211
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.853 45.5686L228.706 130.421L143.853 215.274",
    stroke: "white",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8_61)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -422,
    y: -430,
    width: 1236,
    height: 1202,
    fill: "#47DEFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 260,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72d265fc025835ae7fa79f85a80483b8.svg";
export { ForwardRef as ReactComponent };